module.exports = __webpack_public_path__ + "static/01-12712880a5d8ba4a6762a96e492431b6.png";